import React, { Suspense } from 'react'
import PublicPageLoader from '../../../component/Elements/publicPageLoader'
import { lazyWithRetry } from '../../../helper/lazyWithRetry'

const OwnerRegistration = lazyWithRetry(() => import(/* webpackChunkName: "registration-owner" */'../../../component/Registration/Owner'))

const OwnerRegistrationPage = React.memo(() => {
	return (
		<Suspense fallback={<PublicPageLoader className="authPage" />}>
			<OwnerRegistration />
		</Suspense>
	)
})

OwnerRegistrationPage.displayName = 'OwnerRegistrationPage'
export default OwnerRegistrationPage
